import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--submit-on-change"
// Submits the form of a select, checkbox or date input as soon as its value
// changes. With a delay value the submit waits until the input has been quiet
// for that many milliseconds, e.g. while a date is still being typed.
export default class extends Controller {
  static values = { delay: Number };

  disconnect() {
    clearTimeout(this.timeout);
  }

  submit() {
    clearTimeout(this.timeout);
    // Typing a year makes a date input pass through 0002, 0020, 0202, …
    if (this.element.type === "date" && /^0/.test(this.element.value)) return;

    if (this.delayValue > 0) {
      this.timeout = setTimeout(
        () => this.element.form.requestSubmit(),
        this.delayValue,
      );
    } else {
      this.element.form.requestSubmit();
    }
  }
}
